export { MerchandisingCoBrandCardComponent } from './MerchandisingCoBrandCard';
